import React from 'react';
import classnames from 'classnames';
import ErrorNotice from '../notice/standard-error';
import SuccessNotice from '../notice/standard-success';
import { popUpClose } from '../../actions/pop-ups';
import { resetPreview } from '../../actions/preview';
import {
  updateDataFile,
  createDataFile,
  retrieveData
} from '../../actions/fetch-data';
import Checklist from '../checklist/checklist';
import {
  SERVER_FAILURE_ERROR,
  SERVER_SUCCESS_UPDATE
} from '../../constants/messages';


export default class DefaultAddWithPreview extends React.Component {
  fileRef = React.createRef();


  handleSubmit(e){
    e.preventDefault();

    const file = e.target.querySelector('input[name=document]').files[0];
    const {
      updateAction,
      updateEndpoint,
      putData,
      dispatch,
    } = this.props;

    dispatch(
      updateDataFile(
        updateEndpoint,
        updateAction,
        putData(file)
      )
    );
  }

  handlePreview(e){
    e.preventDefault();
    const file = this.fileRef.current.files[0];
    const {
      previewAction,
      previewEndPoint,
      putData,
      dispatch
    } = this.props;

    if(!file) return;

    dispatch(
      createDataFile(
        previewEndPoint,
        previewAction,
        putData(file)
      )
    );
  }

  render(){
    const {
      title,
      sectionTitle,
      dispatch,
      previewData,
      asyncAction
    } = this.props;

    const {
      requestActive,
      updateSuccess,
      updateFailed,
      errMsg
    } = asyncAction;

    const loadingClasses = classnames({
      'loading--left': true,
      hide: !requestActive
    });

    return(
      <div className="modal">
        <div className="modal-dialog modal-dialog--large">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                aria-hidden="true"
                onClick={(e) => {
                  e.preventDefault()
                  dispatch( popUpClose() )
                  dispatch( resetPreview() )
                }}
              >&times;</button>
              <h4 className="modal-title">{`Edit ${sectionTitle}: ${title}`}</h4>
            </div>
            <div className="modal-body modal-body--dark">
              <div className="pure-g">
                <div className="pure-u-1 pure-u-md-10-24">
                  <form className="pure-form pure-form-stacked" onSubmit={this.handleSubmit.bind(this)} encType="multipart/form-data" autoComplete="off">
                    <ErrorNotice msg={errMsg || SERVER_FAILURE_ERROR} shouldDisplay={updateFailed} />
                    <SuccessNotice msg={SERVER_SUCCESS_UPDATE} shouldDisplay={updateSuccess && previewData.hasBeenSubmited} />

                    <div className="pure-control-group">
                      <label htmlFor="document">Upload a checklist:</label>
                      <input ref={this.fileRef} type="file" name="document" id="file-input" required/>
                    </div>

                    <div className="pure-controls clearfix">
                      <button
                        onClick={this.handlePreview.bind(this)}
                        type="button"
                        className="btn button-success pure-button fl"
                        disabled={previewData.hasBeenPreviewed}
                      ><i className="fa fa-eye"></i> Preview</button>

                      <button
                        type="submit"
                        className="btn pure-button button-primary fr"
                        disabled={!previewData.hasBeenPreviewed || updateSuccess && previewData.hasBeenSubmited}
                      ><i className="fa fa-check"></i> Save Changes
                      </button>

                      {(previewData.hasBeenPreviewed)? (
                        <div className="clearfix center-content">
                          <button
                            type="button"
                            className="btn button-warning pure-button"
                            onClick={(e) => {
                              e.preventDefault();
                              dispatch( resetPreview() );
                            }}
                            disabled={updateSuccess && previewData.hasBeenSubmited}
                          ><i className="fa fa-refresh"></i> Something's not right?
                          </button>
                        </div>
                      ):(null)}
                    </div>
                  </form>
                </div>
                <div className="pure-u-1 pure-u-md-14-24 preview-side">
                  <div className="l-box-2">
                    <Checklist data={previewData.data} />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <img
                className={loadingClasses}
                src={require('../../../images/loading-c.gif')}
              />
              <button
                onClick={(e) => {
                  e.preventDefault();
                  dispatch( popUpClose() )
                  dispatch( resetPreview() )
                }}
                className="btn button-cancel pure-button"
              >Cancel</button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
